/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["search-page{display:block;width:100%}search-page h1{font-weight:400;font-size:2rem;margin-bottom:40px}search-page h1 .query{font-weight:500}search-page .main-container{margin-top:30px;margin-bottom:30px;min-height:calc(100% - 351px)}search-page .type-container{margin:20px 0}search-page .type-container>.title{font-size:2.5rem;margin-bottom:20px;padding-bottom:10px;border-bottom:1px solid var(--be-divider-default)}"];
export { styles as styles };
